export const L10Errors = /** @type {const} */ ({
  generic: 'Something went wrong. Please try again.',
  impromptu: {
    alreadyDialledIn:
      'Another meeting is already being recorded with same meeting link. Please use a different meeting link.',
    default:
      'Please check your online meeting details and enter a valid join meeting link or dial-in number.'
  },
  recording: {
    participant_recording:
      'Recording as participant is not supported on this plan.',
    limit_exceeded: 'Recording limit exceeded. Please upgrade your plan.'
  },
  snippetSummarization:
    'AI summarization of snippet title and description went wrong, you can still manually add one and create a snippet.',
  wrongFormat: 'Unsupported file format!'
});
